import React from 'react';

import getRoleBasedPath from '../../helpers/getRoleBasedPath';

import { ProductCollectionLink } from '../../components/Links';
import {
  columnCreatedAt,
  columnUpdatedAt,
} from '../../components/common';

export const columnNameAdmin = {
  path: 'name',
  width: '100%',
  sort: 'name',
  link: '/collections/:_id',
};

export const columnNameSeller = {
  path: 'name',
  width: '100%',
  sort: 'name',
  link: '/store/collections/:_id',
};

export const columnStore = {
  title: 'Store',
  path: 'store.name',
  link: '/stores/:store._id',
};

export const columnProducts = {
  path: 'products',
  sort: 'products',
  render: (record, column, props) => (
    record.products > 0
    ? (
        <ProductCollectionLink
          location={props.location}
          subject={record}
          pathname={getRoleBasedPath(props, '/products')}
          valuePath="_id"
        >
          {`${record.products}`}
        </ProductCollectionLink>
      )
    : '0'
  ),
};

export const ADMIN = [
  columnNameAdmin,
  columnStore,
  columnProducts,
  columnCreatedAt,
  columnUpdatedAt,
];

export const SELLER = [
  columnNameSeller,
  columnProducts,
  columnCreatedAt,
  columnUpdatedAt,
];
